import React from "react";
import { ReactComponent as Logo } from "./components/logo/logo.svg";
import { ReactComponent as ReloadIcon } from "./components/icons/reload.svg";
import { useAppState } from "./context/appContex";
import NavItem from "./components/desktop/NavItem";
import { ReactComponent as SearchIcon } from "./components/icons/search.svg";
import FeatherIcon from "feather-icons-react";
import Actions from "./components/common/Actions";
import { useMediaQuery } from "react-responsive";
import { IMenuData } from "./@types/types";
import deskTopStyles from "./styles/desktopStyles";

export const InitialRender: React.FC = () => {
  const { init, clientCode, accountLang, user, theme } = useAppState();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 820px)" });

  const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;
  const value = sessionStorage.getItem(cachePhrase);
  const savedMenu = JSON.parse(value ? value : JSON.stringify("")) as IMenuData;

  const showRefreshButton = !!(clientCode && accountLang) && !value;

  const renderInfo = () => {
    if (!clientCode && !accountLang) {
      return (
        <>
          <mark
            style={{
              marginRight: "5px",
              paddingRight: "5px",
              paddingLeft: "5px",
            }}
          >
            clientCode
          </mark>
          and
          <mark
            style={{
              marginRight: "5px",
              marginLeft: "5px",
              paddingRight: "5px",
              paddingLeft: "5px",
            }}
          >
            accountLang
          </mark>
          are required
        </>
      );
    }
    if (!clientCode) {
      return (
        <>
          <mark
            style={{
              marginRight: "5px",
              paddingRight: "5px",
              paddingLeft: "5px",
            }}
          >
            clientCode
          </mark>{" "}
          is required
        </>
      );
    }

    if (!accountLang) {
      return (
        <>
          <mark
            style={{
              marginRight: "5px",
              paddingRight: "5px",
              paddingLeft: "5px",
            }}
          >
            accountLang
          </mark>{" "}
          is required
        </>
      );
    }
  };

  return (
    <>
      <style>{deskTopStyles}</style>
      <nav className='nav'>
        <div className='left-item'>
          <div className='first-row'>
            <Logo />
          </div>
          {!clientCode || !accountLang ? (
            <div className='second-row'>{renderInfo()}</div>
          ) : (
            <>
              {savedMenu && !isTabletOrMobile ? (
                <>
                  <div className='nav-item'>
                    <SearchIcon />
                  </div>
                  <ul className='second-row'>
                    {savedMenu?.items.map((item, index) => {
                      if (item.isVisible) {
                        return (
                          <NavItem
                            item={item}
                            isFirst={index === 0}
                            key={item.id}
                            toggleNavItem={() => null}
                            selectedId={""}
                          />
                        );
                      } else {
                        return null;
                      }
                    })}
                  </ul>
                </>
              ) : null}
            </>
          )}
        </div>
        {showRefreshButton && (
          <button
            type='button'
            className='btn btn-main init-render'
            onClick={() => init("REFRESH")}
          >
            <ReloadIcon />
            Reload Menu
          </button>
        )}

        {savedMenu && !showRefreshButton ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <FeatherIcon
              icon={theme === "dark" ? "sun" : "moon"}
              style={{ cursor: "pointer", marginRight: "20px" }}
            />
            <Actions toggleDropDown={() => null} />
          </div>
        ) : null}
      </nav>
    </>
  );
};
